import {action, makeObservable, observable, runInAction} from 'mobx'

export class ProductImagesStore {
  @observable
  imageLoading: {
    mainImage: {
      subscribed: boolean
      loading: boolean
      el?: any
    }
    backImage: {
      subscribed: boolean
      loading: boolean
      el?: any
    }
  } = {
    mainImage: {
      subscribed: false,
      loading: true,
    },
    backImage: {
      subscribed: false,
      loading: true,
    },
  }

  constructor() {
    makeObservable(this)
  }

  @action.bound
  imageEvents(element: HTMLImageElement, imageType: 'front' | 'back') {
    try {
      const key = imageType == 'front' ? 'mainImage' : 'backImage'
      const subscribed = this.imageLoading[key].subscribed

      if (!subscribed) {
        const imageLoaded = () => {
          this.imageLoading = {
            ...this.imageLoading,
            [key]: {
              ...this.imageLoading[key],
              loading: false,
              el: element,
            },
          }
        }

        const onLoadHandler = () => {
          runInAction(imageLoaded)
        }

        if (element.complete) {
          runInAction(imageLoaded)
        } else {
          element.onload = onLoadHandler
          element.onerror = onLoadHandler
        }

        runInAction(() => {
          this.imageLoading = {
            ...this.imageLoading,
            [key]: {
              el: element,
              ...this.imageLoading[key],
              subscribed: true,
            },
          }
        })
      }
    } catch (e) {
      console.error(e)
    }
  }
}
